// extracted by mini-css-extract-plugin
export var alignCenter = "_af-d";
export var bannerShown = "_af-6";
export var buttonContent = "_af-0";
export var cardList = "_af-1";
export var centerContent = "_af-2";
export var chevron = "_af-3";
export var closePanelButton = "_af-k";
export var conversationContextContainer = "_af-l";
export var conversationDetailContainer = "_af-4";
export var detailWrapper = "_af-7";
export var dropdownButton = "_af-e";
export var dropdownTitle = "_af-9";
export var fullHeight = "_af-5";
export var hidden = "_af-a";
export var icon = "_af-b";
export var mergeSuggestionWrapper = "_af-m";
export var panel = "_af-i";
export var portalButtonsWrapper = "_af-c";
export var right = "_af-j";
export var tableSummaryContainer = "_af-8";
export var tableSummaryHeader = "_af-g";
export var threeDotsButton = "_af-f";
export var wide = "_af-h";